import React, { useState } from 'react';
import Button from '@ids/button';
import Dropdown, { MenuItem } from '@ids-ts/dropdown';
import { useDispatch, useSelector } from 'react-redux';
import InlineMessage from '@ids-beta/inline-message';
import { useEffect } from 'react';
import { ReduxEvent } from '../../../assets/pagedata/constant';
import { getMiscData, addToCartPut } from '../../services/checkoutDataService';
import {
  passOptionsToCustomization,
  createOutOfStockListForVariant,
  isProductOutOfStock,
  convertToSnakeCase,
} from '../Util/CommonUtils';
import { reactCustomizationUrl } from '../Util/CustomizationUtil';
import Loader from '../Common/Loader';

export const AddToCartGetCustomXsellPricing = (props) => {
  const [printerValue, setPrinterValue] = useState({ value: 'Laser_InkJet' });
  const [sheetsValue, setSheetValue] = useState({ value: 1 });
  const [cartSuccess, setCartSuccess] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showPageLoader, setShowPageLoader] = useState(false);
  const [quantityValue, setQuantityValues] = useState(null);
  const [quantityList, setQuantityList] = useState(null);
  const [outOfStockList, setOutOfStockList] = useState(null);
  const [outOfStockBaseSku, setOutOfStockBaseSku] = useState(null);
  const [outOfStockSingleSku, setOutOfStockSingleSku] = useState(null);
  const [inv01Sheets, setInv01Sheets] = useState([1, 2, 3, 4]);
  const [state01Sheets, setState01Sheets] = useState([1, 2]);

  const priceChange =
    props.skuList && props.skuList[0] && props.skuList[0][0] && props.skuList[0][0].DiscPrice;

  const mainReducer = useSelector((state) => state.mainReducer);

  const handleSingleSkuOutOfStock = (sku) => {
    if (sku && sku.length > 0) {
      const outOfStockStatusSku = isProductOutOfStock(
        {
          pfid: null,
          sku,
        },
        outOfStockList,
      );
      setOutOfStockSingleSku(outOfStockStatusSku);
    }
  };

  useEffect(() => {
    setShowLoader(true);
    const options = {
      productId: props.pfid,
      printerType: printerValue.value,
      sheet: sheetsValue.value,
    };
    getMiscData(options)
      .then((res) => {
        setQuantityList(res.fsg_variant);
        const ofsList = createOutOfStockListForVariant(res.fsg_variant);
        setOutOfStockBaseSku(ofsList[0].baseSkuList[0]);
        setOutOfStockList(ofsList);
        if (res.fsg_variant && res.fsg_variant.length) {
          setQuantityValues(res.fsg_variant[0].sku);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        props.logToIMWebLogger('error', `Xsell: getMiscData call Failed. Error: ${err}`);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.pfid, printerValue, sheetsValue, priceChange]);

  useEffect(() => {
    if (quantityValue?.length >= 1) {
      handleSingleSkuOutOfStock(quantityValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantityValue]);

  const dispatch = useDispatch();

  const sheetsPerProduct = {
    'INV-01': inv01Sheets,
    'STATE-01': state01Sheets,
    'DEP-01': [1, 2, 3],
    'DEP-02': [1, 2, 3],
  };

  const isCustomProduct = () => {
    return !!(
      props.product &&
      props.product.Products &&
      props.product.Products[0].IsCustomizable === '1' &&
      props.product.Products[0].ImprintId === 0
    );
  };

  const handlePrinterValueChange = (e) => {
    const printerTyp = e.target.value;
    if (props.pfid === 'INV-01' && printerTyp === 'Dot_Matrix') {
      setSheetValue({ value: 2 });
      setInv01Sheets([2, 3, 4]);
    }
    if (props.pfid === 'STATE-01' && printerTyp === 'Dot_Matrix') {
      setSheetValue({ value: 2 });
      setState01Sheets([2]);
    } else if (props.pfid === 'STATE-01' && printerTyp === 'Laser_InkJet') {
      setState01Sheets([1, 2]);
    }
    setPrinterValue({ value: printerTyp });
  };

  const handleSheetNumberChange = (e) => {
    setSheetValue({ value: e.target.value });
  };

  const handleQuantityChange = (e) => {
    setQuantityValues(e.target.value);
  };

  const handleGetStarted = (id) => {
    const options = {
      sku: quantityValue,
    };
    passOptionsToCustomization(options);
    let url = '';
    const urlMap = reactCustomizationUrl[id];
    url = `${urlMap}?sku=${quantityValue}&sheets=${sheetsValue.value}`;
    props.history.push(url);
  };

  const addToCartSuccess = (pageInfo) => {
    props.logToIMWebLogger(
      'info',
      `XsellPage -> AddToCartGetCustomXsellPricing: handleAddToCart success`,
    );
    dispatch({
      type: ReduxEvent.PAGE_DATA,
      data: {
        pageData: {
          cartCount: pageInfo.CartCount,
          login: pageInfo.login,
          promotionMessage: pageInfo.PromotionMessage,
        },
      },
    });
    const linkData = {
      linkName: 'cartadd',
      aryProducts: [[props.pfid]],
      eventList: 'cartadd',
    };
    props.logToAnalytics({ linkData }, 'link');
    if (props.cartXsellCallBack) {
      props.cartXsellCallBack();
    } else {
      setCartSuccess(true);
    }
    setShowPageLoader(false);
  };

  const addToCartFailed = (err) => {
    props.logToIMWebLogger(
      'error',
      `XsellPage -> AddToCartGetCustomXsellPricing: handleAddToCart failed. Reason: ${err}`,
    );

    props.displayToast('Some error occured. Please try again.');
    setShowPageLoader(false);
    setCartSuccess(false);
  };

  const handleAddToCart = () => {
    props.logToIMWebLogger(
      'info',
      `XsellPage -> AddToCartGetCustomXsellPricing: handleAddToCart called`,
    );

    setShowPageLoader(true);

    if (mainReducer.pageData.cartCount >= 30) {
      props.cartLimitExceed();
      setShowPageLoader(false);
      return;
    }

    const params = {
      IsCustomizable: props.product.Products[0].IsCustomizable,
      PfId: props.pfid,
      SKU: quantityValue,
      ImprintId: props.product.Products[0].ImprintId,
    };

    addToCartPut(params, addToCartSuccess, addToCartFailed);
  };

  const formatPrice = (val) => {
    const price = val.split('.', 2);
    return (
      <span>
        {price[0]} <sup className="xsell-sup-price">{price[1]}</sup>
      </span>
    );
  };

  const formatCost = (value) => {
    if (props.pfid === 'STAMP-19') {
      return formatPrice(parseFloat(value / 100, 10).toFixed(2));
    }
    return parseFloat(value / 100, 10).toFixed(2);
  };

  if (props.pfid === 'STAMP-19') {
    return (
      <div>
        <Loader show={showPageLoader} size={80} loadingText="Please wait..." />
        <div className="xsell-product-description">
          Stop hand-endorsing checks for deposit. Get your own business endorsement stamp!
        </div>
        <div className="xsell-price-text margin-top-20">
          <span className="xsell-price">
            {' '}
            {showLoader && <p className="loaderTxt">Loading...</p>}
            {!showLoader && <>$ {quantityList && formatCost(quantityList[0].list_price_cents)}</>}
          </span>
        </div>
        {outOfStockSingleSku?.displayOutOfStock ? (
          <div className="product-unavailable-msg margin-bottom-20">
            {outOfStockSingleSku.outOfStockMessage}
          </div>
        ) : outOfStockBaseSku?.displayOutOfStock ? (
          <div className="product-unavailable-msg margin-bottom-20">
            {outOfStockBaseSku.outOfStockMessage}
          </div>
        ) : (
          <Button
            theme="intuit"
            buttonType="primary"
            className="xsell-button checkout-btn checkout-primary-btn"
            disabled={cartSuccess}
            onClick={() => {
              isCustomProduct() ? handleGetStarted(props.pfid) : handleAddToCart();
            }}
            data-wa-link="Continue checkout"
            data-ui-object="button"
            data-refer-ui-access-point={`${
              isCustomProduct() ? 'get_started_xsell' : 'add_to_cart_xsell'
            } | ${convertToSnakeCase(props.product.Name)}`}
          >
            {isCustomProduct() ? 'Get Started' : 'Add to cart'}
          </Button>
        )}
        <InlineMessage
          isStatic
          open={cartSuccess}
          className="added-msg"
          content={<div>Added to Cart</div>}
        />
      </div>
    );
  }
  return (
    <div>
      <Loader show={showPageLoader} size={80} loadingText="Please wait..." />
      {(props.pfid === 'INV-01' ||
        props.pfid === 'STATE-01' ||
        props.pfid === 'DEP-01' ||
        props.pfid === 'DEP-02') && (
        <>
          {(props.pfid === 'INV-01' || props.pfid === 'STATE-01') && (
            <div className="xsell-printer-container">
              <div className="xsell-label">Printer type</div>
              <Dropdown
                role="option"
                theme="quickbooks"
                aria-label="XsellDropdown"
                value={printerValue.value}
                onChange={handlePrinterValueChange}
                className="xsell-dropDown dropdown-background-color-white"
                disabled={cartSuccess}
              >
                <MenuItem value="Laser_InkJet">Laser/InkJet</MenuItem>
                <MenuItem value="Dot_Matrix">Dot Matrix</MenuItem>
              </Dropdown>
            </div>
          )}
          <div className="xsell-sheets-container">
            <div className="xsell-label"># of sheets</div>
            <Dropdown
              role="option"
              theme="quickbooks"
              aria-label="XsellDropdown"
              value={sheetsValue.value}
              onChange={handleSheetNumberChange}
              className="xsell-dropDown dropdown-background-color-white"
              disabled={cartSuccess}
            >
              {sheetsPerProduct[props.pfid].map((sheet) => {
                return <MenuItem value={sheet}>{sheet}</MenuItem>;
              })}
            </Dropdown>
          </div>
        </>
      )}
      {!outOfStockBaseSku?.displayOutOfStock && (
        <div className="xsell-quantity-container">
          <div className="xsell-label">Quantity</div>
          <Dropdown
            role="option"
            theme="quickbooks"
            value={quantityValue}
            aria-label="XsellDropdown"
            onChange={handleQuantityChange}
            className="xsell-dropDown dropdown-background-color-white"
            placeholder="Loading..."
            disabled={cartSuccess}
          >
            {quantityList &&
              quantityList.map((q, key) => {
                return (
                  <MenuItem key={`${key}`} value={`${q.sku}`}>{`${q.quantity} for ${`$ ${formatCost(
                    q.list_price_cents,
                  )}`}`}</MenuItem>
                );
              })}
          </Dropdown>
        </div>
      )}

      {outOfStockSingleSku?.displayOutOfStock ? (
        <div className="product-unavailable-msg margin-bottom-20">
          {outOfStockSingleSku.outOfStockMessage}
        </div>
      ) : outOfStockBaseSku?.displayOutOfStock ? (
        <div className="product-unavailable-msg margin-bottom-20">
          {outOfStockBaseSku.outOfStockMessage}
        </div>
      ) : (
        <Button
          theme="quickbooks"
          buttonType="secondary"
          className="xsell-button"
          onClick={() => {
            isCustomProduct() ? handleGetStarted(props.pfid) : handleAddToCart();
          }}
          disabled={cartSuccess}
          data-wa-link={isCustomProduct() ? `Get started : ${props.pfid}` : ``}
          data-ui-object="button"
          data-refer-ui-access-point={`${
            isCustomProduct() ? 'get_started_xsell' : 'add_to_cart_xsell'
          } | ${convertToSnakeCase(props.product.Name)}`}
        >
          {isCustomProduct() ? 'Get Started' : 'Add to cart'}
        </Button>
      )}
      <InlineMessage
        isStatic
        open={cartSuccess}
        className="added-msg"
        content={<div>Added to Cart</div>}
      />
    </div>
  );
};
